<div attr.name="CellOS_{{ item.name }}" class="tCol clickCol desktop" id="CellOS_{{ item.id }}">
  @if (item.jwt) {
    <span>--</span>
  }
  @if (!item.jwt) {
    <span>{{ item[type] }}</span>
  }
</div>
